module.exports = __webpack_public_path__ + "img/three2Blue.8fa48688.jpg";